import { ValidatorFn, AbstractControl, ValidationErrors } from '@angular/forms';

/**
 * Validator for Azure DCE URI format
 * Must use HTTPS and end with .ingest.monitor.azure.com
 */
export function dceUriValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const value = control.value as string;

    // Check if it starts with https://
    if (!value.startsWith('https://')) {
      return { invalidDceUri: { value, message: 'DCE URI must start with https://' } };
    }

    // Validate URL format
    try {
      const url = new URL(value);

      // Check if hostname is valid (not empty, has proper format)
      if (!url.hostname || url.hostname.length === 0) {
        return { invalidDceUri: { value, message: 'DCE URI must have a valid hostname' } };
      }

      // Check if it ends with the correct domain
      if (!url.hostname.endsWith('.ingest.monitor.azure.com')) {
        return {
          invalidDceUri: {
            value,
            message: 'DCE URI hostname must end with .ingest.monitor.azure.com',
          },
        };
      }
    } catch {
      return { invalidDceUri: { value, message: 'DCE URI is not a valid URL' } };
    }

    return null;
  };
}

/**
 * Validator for Azure DCR Immutable ID format
 * Must start with "dcr-"
 */
export function dcrIdValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) {
      return null;
    }
    const value = control.value as string;
    if (!value.startsWith('dcr-')) {
      return { invalidDcrId: { value, message: 'DCR Immutable ID must start with "dcr-"' } };
    }
    return null;
  };
}
